import { createReducer } from 'redux-create-reducer';
import callAPI from '../../../utils/callAPI';

// RESET PASSWORD
export const ACTION_REQUEST_RESET_PASSWORD = 'ACTION_REQUEST_RESET_PASSWORD';
export const REQUEST_RESET_PASSWORD = 'REQUEST_RESET_PASSWORD';
export const REQUEST_RESET_PASSWORD_SUCCESS = 'REQUEST_RESET_PASSWORD_SUCCESS';
export const REQUEST_RESET_PASSWORD_FAILURE = 'REQUEST_RESET_PASSWORD_FAILURE';

const defaultState = {
  // RESET
  resetPasswordRequesting: false,
  resetPasswordFailure: false,
  resetPasswordSuccess: false,
};

const reducer = createReducer(defaultState, {
  // RESET PASSWORD
  [REQUEST_RESET_PASSWORD]: (state) => ({
    ...state,
    resetPasswordRequesting: true,
    resetPasswordSuccess: false,
    resetPasswordFailure: false,
  }),
  [REQUEST_RESET_PASSWORD_SUCCESS]: (state) => {
    return {
      ...state,
      resetPasswordFailure: false,
      resetPasswordSuccess: true,
      resetPasswordRequesting: false,
    };
  },
  [REQUEST_RESET_PASSWORD_FAILURE]: (state) => {
    return {
      ...state,
      resetPasswordFailure: true,
      resetPasswordRequesting: false,
      resetPasswordSuccess: false,
    };
  },
});

export default reducer;
export const namespace = 'resetPassword';

export const resetPasswordAction = (credentials) => ({
  type: ACTION_REQUEST_RESET_PASSWORD,
  payload: credentials,
});

export const resetPasswordAPI = (payload) => async (dispatch, getState) => {
  return await callAPI({
    method: 'post',
    apiPath: `/auth/reset-password/${payload?.token}`,
    actionTypes: [
      REQUEST_RESET_PASSWORD,
      REQUEST_RESET_PASSWORD_SUCCESS,
      REQUEST_RESET_PASSWORD_FAILURE,
    ],
    variables: {
      ...payload,
    },
    dispatch,
    getState,
  });
};
